import { useFormikContext } from "formik";
import { SelectPresenter, type SelectPresenterProps } from "./SelectPresenter";

export interface FormikSelectPresenterProps extends SelectPresenterProps {
  name: string;
}

export const FormikSelectPresenter = ({
  name,
  ...props
}: FormikSelectPresenterProps) => {
  const { setFieldValue } = useFormikContext();

  return (
    <SelectPresenter
      {...props}
      onChange={(value) => {
        setFieldValue(name, value);
      }}
    />
  );
};
